import { render, staticRenderFns } from "./wikiViewerContents.vue?vue&type=template&id=3544ac92&scoped=true&"
import script from "./wikiViewerContents.vue?vue&type=script&lang=js&"
export * from "./wikiViewerContents.vue?vue&type=script&lang=js&"
import style0 from "./wikiViewerContents.vue?vue&type=style&index=0&id=3544ac92&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3544ac92",
  null
  
)

export default component.exports